import { FormControl, FormGroup } from '@angular/forms';

import { createDatasourceForm } from '../../../datasource-form';

import { FormType } from './types';
import { BACK_SOURCE_TYPES, FRONT_SOURCE_TYPES } from './constants';

export const createForm = () => {
  return new FormGroup<FormType>({
    dependsOn: new FormControl([], { nonNullable: true }),
    front: createDatasourceForm({ type: FRONT_SOURCE_TYPES[0] }),
    back: createDatasourceForm({ type: BACK_SOURCE_TYPES[0] }),
  });
};
